
export const calculateLumpsumReturns = (lumpsumAmount, tenureInYears, annualReturnRate) => {
    const annualRate = annualReturnRate / 100; // Convert percentage to decimal
    const futureValue = lumpsumAmount * Math.pow(1 + annualRate, tenureInYears); // Corrected future value formula
    const profit = futureValue - lumpsumAmount; // Profit is Future Value - Principal
    const profitPercentage = (profit / lumpsumAmount) * 100; // Profit percentage

    return {
        lumpsumAmount: Math.round(lumpsumAmount),
        tenureInYears,
        annualReturnRate,
        totalValue: Math.round(futureValue), // Future value rounded
        profit: Math.round(profit), // Profit rounded
        investedAmount: Math.round(lumpsumAmount), // Principal rounded
        profitPercentage: Math.round(profitPercentage), // Profit percentage rounded
    };
};

export const generateReport = (lumpsumAmount, tenureInYears, expectedReturnRate) => {
    const lumpsumReport = calculateLumpsumReturns(lumpsumAmount, tenureInYears, expectedReturnRate);
    let reportOfMultipleYears = [];
    for (let year = 0; year <= tenureInYears; year++) {
        reportOfMultipleYears.push(calculateLumpsumReturns(lumpsumAmount, year, expectedReturnRate))
    }
    return {
        lumpsumReport,
        reportOfMultipleYears
    };
};
